import React from "react";
import { Pill as CoreView } from "@jelly/ui";

import defaultStyle from "./Pill.module.scss";

export const Pill: React.FC<React.ComponentProps<typeof CoreView>> = (props) => {
  return <CoreView {...props} style={defaultStyle} />;
};
